import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/SEO/SEOPage';
import Layout from '../components/shared/layout';
import { wrapper, color, breakpoints } from '../utils/style';
import styled from '@emotion/styled';
import ButtonLink from '../components/shared/ButtonLink';
import Parallax from "../components/shared/Parallax"

const Wrapper = styled('div')`
  ${wrapper}
  .info-wrapper {
    margin: 30px auto;
    padding: 60px 30px;
    background: ${color.transparentWhite1};
    border-radius: 16px;
    text-align: center;
    h1 {
      margin:0 0 30px;
    }
    p {
      margin: 30px 0;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .info-wrapper {
      padding: 30px 15px;
    }
  }
  
`;

const NotFoundPage = ({ data }) => (
  <Layout>
    <SEO title='ลงทะเบียนเสร็จสมบูรณ์!'/>
    <Parallax />
    <Wrapper>
      <div className={"info-wrapper"}>
        <h1>ลงทะเบียนเสร็จสมบูรณ์!</h1>
        <p>กรุณาเช็คอีเมลของคุณเพื่อเปิดการใช้งานบัญชีเกมฟรี</p>
        <ButtonLink to="/" text="กลับไปยังหน้าโฮมเพจ" ariaText="กลับไปยังหน้าโฮมเพจ"/>
      </div>
    </Wrapper>
  </Layout>
);

export default NotFoundPage;

// Set here the ID of the home page.
export const pageQuery = graphql`
  query {
    missing: file(relativePath: { eq: "404.png" }) {
      childImageSharp {
          fluid(maxWidth: 480) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }   
  }
`;
